<ng-container *ngIf="this.HasFolderOrFormInstance != null">
    <h1 mat-dialog-title
        class="draggable-dialogue-header title-h"
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragHandle>
        {{this.Title}}
    </h1>

    <div mat-dialog-content
         class="mat-dialog-content-div">
        <ng-container *ngIf="this.Initialized">
            <mat-horizontal-stepper linear
                                    #stepper
                                    class="magic-structure-def-mat-stepper">
                <mat-step>
                    <form [formGroup]="this.StructureBasicInfoFormGroup">
                        <ng-template matStepLabel>Enter {{this.MagicStructureTypeName}} Name</ng-template>

                        <div>
                            <span class="source-structure-name-label-span">Source {{this.SourceStructureTypeName}} Name: </span>
                            <span class="source-structure-name-span">{{this.SourceStructureName}}</span>
                        </div>

                        <div class="magic-structure-name-div">
                            <span class="magic-folder-span">{{this.MagicStructureTypeName}} Name:</span>

                            <mat-form-field class="magic-structure-name-mat-form-field">
                                <mat-label>{{this.MagicStructureTypeName}} Name</mat-label>

                                <input matInput
                                       formControlName="structureName"
                                       placeholder="{{this.MagicStructureTypeName}} Name"
                                       class="magic-structure-name-mat-input" />
                            </mat-form-field>
                        </div>

                        <div class="use-standard-name-for-all-copies-div">
                            <div class="standard-name-for-all-copies-div">
                                <span class="standard-structure-name-span">Name for all Copies:</span>

                                <mat-form-field class="standard-structure-name-mat-form-field">
                                    <mat-label>{{this.MagicStructureTypeName}} Copy Name</mat-label>

                                    <input matInput
                                           formControlName="standardStructureName"
                                           placeholder="{{this.MagicStructureTypeName}} Copy Name"
                                           class="standard-structure-name-mat-input" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div>
                            <span class="standard-structure-name-span">Role Name(s):</span>

                            <mat-form-field appearance="fill"
                                            [floatLabel]="'always'"
                                            class="scheduled-time-mat-form-field">
                                <mat-label class="scheduled-time-label">Role(s)</mat-label>

                                <mat-select multiple
                                            formControlName="roleNames"
                                            [disabled]="this.RoleNamesDisabled"
                                            class="scheduled-time-mat-select">
                                    <mat-option *ngFor="let roleName of this.RoleNames"
                                                [value]="roleName">
                                        {{roleName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="standard-structure-name-required-error-div">
                            <!-- Define a conditional error message. -->
                            <small class="standard-structure-name-required-error-small">{{this.BasicSectionInfoMissingText}}</small>
                        </div>

                        <div class="magic-structure-name-buttons-div">
                            <div class="next-button-div"
                                 [matTooltipPosition]="this.TooltipPosition"
                                 matTooltip="{{this.BasicSectionInfoMissingText}}">
                                <button mat-button
                                        matStepperNext
                                        color="primary"
                                        class="theme-primary-btn"
                                        [disabled]="this.DisableBasicInfoSectionAdvancement"
                                        (click)="this.advanceToMembershipSection()">
                                    Next
                                </button>
                            </div>

                            <button mat-flat-button
                                    color="basic"
                                    style="margin-left: 10px;"
                                    (click)="this.cancel()">
                                Cancel
                            </button>
                        </div>
                    </form>
                </mat-step>

                <mat-step>
                    <ng-container>
                        <ng-template matStepLabel>{{this.ConfigureMembershipsStepName}}</ng-template>

                        <!-- Define a list of existing users and/or groups. -->
                        <div class="membership-mat-table-div">
                            <!--
                            <table mat-table
                                   [dataSource]="this.StructureMemberships"
                                   class="mat-elevation-z4 membership-mat-table"
                                   multiTemplateDataRows>
                                <ng-container matColumnDef="MembershipName">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                        class="membership-name-mat-header-cell">
                                        {{this.MembershipNameHeaderText}}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let membership"
                                        class="membership-name-mat-cell">
                                        <form [formGroup]="membership.MembershipFormGroup"
                                              class="membership-name-form">
                                            <mat-form-field class="membership-name-mat-form-field">
                                                <mat-label>{{this.MembershipNameHeaderText}}</mat-label>

                                                <input matInput
                                                       formControlName="membershipName"
                                                       placeholder="{{this.MembershipNameHeaderText}}"
                                                       [disabled]="false"
                                                       class="membership-name-mat-input" />
                                            </mat-form-field>
                                        </form>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="RoleNames">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                        class="membership-roles-mat-header-cell">
                                        Role Name(s)
                                    </th>

                                    <td mat-cell
                                        *matCellDef="let membership"
                                        class="membership-roles-mat-cell">

                                        <form [formGroup]="membership.MembershipFormGroup"
                                              class="membership-roles-mat-cell">
                                            <mat-form-field appearance="fill"
                                                            class="membership-role-names-mat-form-field">
                                                <mat-label class="scheduled-time-label">Role(s)</mat-label>

                                                <mat-select multiple
                                                            formControlName="membershipRoleNames"
                                                            [disabled]="false"
                                                            class="scheduled-time-mat-select">
                                                    <mat-option *ngFor="let roleName of membership.AvailableRoleNames"
                                                                [value]="roleName">
                                                        {{roleName}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </form>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Member">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                        class="member-type-mat-header-cell">
                                        Member(s)
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let membership"
                                        class="member-type-mat-cell">
                                        {{this.getMemberDisplayName(membership)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Action">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                        class="action-mat-header-cell">
                                        Actions
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let membership"
                                        class="action-mat-cell">
                                        <mat-checkbox [(ngModel)]="membership.membershipSelected"
                                                      (ngModelChange)="this.membershipSelectionChanged(membership)"
                                                      class="membership-selected-mat-checkbox"
                                                      [matTooltipPosition]="this.TooltipPosition"
                                                      matTooltip="{{this.MembershipSelectionCheckboxTooltip}}"></mat-checkbox>

                                        <mat-icon svgIcon="bootstrap-arrows-expand"
                                                  class="arrows-expand-mat-icon"
                                                  (click)="this.arrowsExpandClicked(membership,$event)"
                                                  [matTooltipPosition]="this.TooltipPosition"
                                                  matTooltip="{{this.MembershipShowHideDetailTooltip(membership)}}"></mat-icon>

                                        <mat-icon svgIcon="trash"
                                                  class="membership-trash-mat-icon"
                                                  (click)="this.deleteMembership(membership)"
                                                  [matTooltipPosition]="this.TooltipPosition"
                                                  matTooltip="{{this.MembershipTrashCanTooltip}}"></mat-icon>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="expandedDetail">
                                    <td mat-cell
                                        *matCellDef="let membership"
                                        [attr.colspan]="4"
                                        class="{{this.MembershipDetailTdClass(membership)}}">
                                        <div>
                                            <table>
                                                <tr *ngFor="let member of membership.members; let mi=index">
                                                    <td class="expanded-detail-empty-structure-name-td"></td>

                                                    <td class="expanded-detail-member-detail-td">
                                                        <span class="expanded-detail-member-detail-span">{{this.MemberDetailText(member)}}</span>
                                                    </td>

                                                    <td class="expanded-detail-member-type-td">
                                                        <span class="expanded-detail-member-type-span">{{this.MemberTypeText(member)}}</span>
                                                    </td>

                                                    <td class="expanded-detail-member-actions-td">
                                                        <div class="expanded-detail-member-actions-div">
                                                            <div class="expanded-detail-member-actions-blank-space-div"></div>

                                                            <ng-container *ngIf="this.MemberCanMoveUp(membership, member, mi)">
                                                                <mat-icon class="move-member-up-mat-icon"
                                                                          (click)="this.moveMemberUp(membership, member, mi)"
                                                                          [matTooltipPosition]="this.TooltipPosition"
                                                                          matTooltip="{{this.MoveMemberUpTooltip}}">arrow_upward</mat-icon>
                                                            </ng-container>
                                                            <ng-container *ngIf="this.MemberCanMoveDown(membership, member, mi)">
                                                                <mat-icon class="move-member-down-mat-icon"
                                                                          (click)="this.moveMemberDown(membership, member, mi)"
                                                                          [matTooltipPosition]="this.TooltipPosition"
                                                                          matTooltip="{{this.MoveMemberDownTooltip}}">arrow_downward</mat-icon>
                                                            </ng-container>

                                                            <mat-icon svgIcon="trash"
                                                                      class="member-trash-mat-icon"
                                                                      (click)="this.deleteMember(membership, member, mi)"
                                                                      [matTooltipPosition]="this.TooltipPosition"
                                                                      matTooltip="{{this.DeleteMemberTooltip}}"></mat-icon>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="this.MembershipTableColumnNames"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: this.MembershipTableColumnNames"></mat-row>
                                <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                         class="{{this.MemberDetailRowClass(row)}}">
                                </mat-row>
                            </table>
                            -->
                            
                            <app-magic-structure-membership [folderOrFormInstance]="this.FolderOrFormInstance"
                                                            (onInit)="this.onMembershipsManagerInit($event)"
                                                            (onMembershipChange)="this.onMembershipChange($event)"
                                                            (onMembershipSelectionChanged)="this.onMembershipSelectionChanged($event)"></app-magic-structure-membership>
                               
                        </div>

                        <form [formGroup]="this.MembershipGeneralInfoFormGroup"
                          class="one-structure-per-member-form">
                            <mat-checkbox formControlName="createOneStructurePerMember"
                                      class="use-standard-structure-name-mat-checkbox"
                                      [matTooltipPosition]="this.TooltipPositionRight"
                                      [disabled]="this.DisableCreateOneStructurePerMemberCheckbox"
                                      matTooltip="{{this.CreateOneStructurePerMemberTooltip}}">{{this.CreateOneStructurePerMemberLabel}}</mat-checkbox>

                            <span class="num-copies-configured-label">{{this.NumCopiesConfiguredLabel}}</span>
                            <span class="num-copies-configured-value-span">{{this.NumCopiesConfiguredValue}}</span>
                        </form>

                        <!-- Define a control for adding a user or a group. -->
                        <app-max-picker class="max-picker-component"
                                        [userGroupPickerLabel]="this.AddMemberLabel"
                                        [maxMemberStyle]="'width: 59%;'"
                                        [addButtonName]="this.AddMembershipButtonTitle"
                                        [addButtonAdditionalStyle]="this.AddMembershipAdditionalStyle"
                                        [addButtonFlyoverText]="this.AddButtonFlyoverText"
                                        [secondButtonName]="this.AddMemberButtonTitle"
                                        [secondButtonCanEnable]="this.AddMemberButtonCanEnable"
                                        [secondButtonFlyoverText]="this.SecondButtonFlyoverText"
                                        (addButtonClicked)="this.addNewMembership($event)"
                                        (secondButtonClicked)="this.addMemberToMembership($event)"></app-max-picker>

                        <div>
                            <button mat-button
                                    matStepperPrevious
                                    color="basic">
                                Back
                            </button>

                            <div class="next-button-div"
                                 [matTooltipPosition]="this.TooltipPosition"
                                 matTooltip="{{this.AtLeastOneMembershipRequiredText}}">
                                <button mat-button
                                        matStepperNext
                                        color="primary"
                                        class="theme-primary-btn"
                                        [disabled]="this.DisableMemberSectionAdvancement">
                                    Next
                                </button>
                            </div>

                            <button mat-flat-button
                                    color="basic"
                                    style="margin-left: 10px;"
                                    (click)="this.cancel()">
                                Cancel
                            </button>

                            <button mat-flat-button
                                    color="basic"
                                    style="margin-left: 10px;"
                                    [disabled]="this.ShowImportFormatButtonDisabled"
                                    (click)="this.showImportFormat()">
                                Show Import Format ...
                            </button>

                            <button mat-flat-button
                                    color="basic"
                                    style="margin-left: 10px;"
                                    [disabled]="this.ShowImportMembershipsButtonDisabled"
                                    (click)="this.importMemberships()">
                                {{this.ImportMembershipsButtonTitle}}
                            </button>

                            <!-- Define a file input dialogue. -->
                            <input type="file"
                                   #importMembershipsFile
                                   class="hidden-file-input"
                                   (change)="this.onImportMembershipsFileChanged($event)" />
                        </div>
                    </ng-container>
                </mat-step>

                <mat-step>
                    <form [formGroup]="this.StructureTriggerFormGroup">
                        <ng-template matStepLabel>Select Trigger</ng-template>

                        <mat-radio-group formControlName="triggerName">
                            <ng-container *ngFor="let triggerName of this.TriggerNames; let i=index">
                                <mat-radio-button value="{{triggerName}}"
                                                  [checked]="this.IsSelectedTrigger(triggerName)"
                                                  [disabled]="false"
                                                  class="trigger-name-mat-radio-button">
                                    {{triggerName}}
                                </mat-radio-button>

                                <ng-container *ngIf="i < (this.NumTriggerNames - 1)">
                                    <br />
                                </ng-container>
                            </ng-container>
                        </mat-radio-group>

                        <br />

                        <ng-container *ngIf="this.ShowDateAndTimeForTrigger">
                            <mat-form-field appearance="fill">
                                <mat-label class="scheduled-date-label">{{this.ScheduleDateLabelText}}</mat-label>

                                <input matInput
                                       #scheduledDate
                                       formControlName="scheduledDate"
                                       [disabled]="this.ScheduleFieldsDisabled"
                                       [min]="this.MinScheduledDate"
                                       [max]="this.MaxScheduledDate"
                                       [matDatepicker]="picker"
                                       class="scheduled-date-input"
                                       placeholder="{{this.ScheduledDatePlaceholderText}}" />

                                <mat-datepicker-toggle matSuffix
                                                       [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker>
                                    <mat-datepicker-actions>
                                        <button mat-button matDatepickerCancel>Cancel</button>
                                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                                    </mat-datepicker-actions>
                                </mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="fill"
                                            [floatLabel]="'always'"
                                            class="scheduled-time-mat-form-field">
                                <mat-label class="scheduled-time-label">{{this.ScheduledTimeLabelText}}</mat-label>

                                <mat-select formControlName="scheduledTime"
                                            [disabled]="this.ScheduleFieldsDisabled"
                                            class="scheduled-time-mat-select">
                                    <mat-option *ngFor="let targetTime of this.AvailableScheduleTimes; let iTargetTime=index"
                                                [value]="targetTime.hoursOffset">
                                        {{targetTime.displayTime}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>

                        <div class="trigger-buttons-div">
                            <button mat-button matStepperPrevious>Back</button>

                            <button mat-flat-button
                                    type="submit"
                                    color="primary"
                                    class="theme-primary-btn"
                                    [disabled]="this.SaveDisabled"
                                    (click)="this.save()">
                                Create
                            </button>

                            <button mat-flat-button
                                    class="basic"
                                    style="margin-left: 10px;"
                                    (click)="this.cancel()">
                                Cancel
                            </button>
                        </div>

                    </form>
                </mat-step>
            </mat-horizontal-stepper>
        </ng-container>
    </div>

    <div *ngIf="!this.Initialized"
         mat-dialog-content
         class="mat-dialog-content-div">
        <p>Loading ...</p>
    </div>
</ng-container>
